<div class="autocomplete-container">
    <input type="text" class="form-control mt-2 autocomplete-input" [placeholder]="placeholder"  [value]="selectedAddress ? selectedAddress : ''"
        [ngClass]="{ 'gradient-border': highlight, 'p-14':highlight }" [readOnly]="readOnly"
        (input)="handleInput($event)" appPlaceAutocomplete (suggestionsChanged)="onSuggestions($event)" />

    <div class="autocomplete-dropdown" *ngIf="suggestions.length">
        <div class="autocomplete-item" *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)">
            <span class="material-icons location-icon">location_on</span>
            <div class="suggestion-text">
                {{ suggestion.placePrediction.text.text }}
            </div>
        </div>
    </div>
</div>